import React, {PureComponent, PropTypes} from 'react';
import Modal from 'react-modal';
import cx from 'classnames';

import style from './team-member-selector.module.css';
import modalStyle from '../modal.module.css';

class TeamMemberSelect extends PureComponent {

    static propTypes = {
        onClose: PropTypes.func,
        open: PropTypes.bool,
        init: PropTypes.bool,
        teamData: PropTypes.object.isRequired,
        teamSelected: PropTypes.number,
        roster: PropTypes.array,
        timeSlotData: PropTypes.object,
        rosterSize: PropTypes.number.isRequired,
        tournamentId: PropTypes.number,
        timeSlotMaxParticipants: PropTypes.number
    };

    constructor(props) {
        super(props);

        this._selects = [];
        this.state = {};
    }

    _resetState() {
        this.setState({
            error: '',
            loading: false,
            success: false,
            reset: false,
            teamSelected: 0,
            roster: []
        });
    }

    _submitForm = (e) => {
        e.preventDefault();

        const teamId = this.props.teamSelected || parseInt(this._teamSelect.value, 10);
        const timeslot = this._timeSlotSelect && this._timeSlotSelect.value;
        let hasValue = false;
        const roster = this._selects.map((item) => {

            if (item.value !== '0') {
                hasValue = true;
            }

            return parseInt(item.value, 10);
        });

        if (!hasValue) {
            return alert(Exanimo.trans('at_least_one_player'));
        }

        if (this.state.loading) {
            return;
        }

        this.setState({
            error: '',
            loading: true
        });

        let url;
        if (this.props.timeSlotData) {
            url = '/tournament/join-team-timeslot';
        } else if (this.props.teamSelected) {
            url = '/tournament/roster';
        } else {
            url = '/tournament/join';
        }

        fetch(url, {
            credentials: 'same-origin',
            method: 'post',
            body: JSON.stringify({
                tournament_id: this.props.tournamentId,
                team_id: teamId,
                roster: roster,
                timeslot,
            }),
            headers:{'X-CSRF-TOKEN': Exanimo.CSRF}
        }).then((response) => {

            if (response.status !== 200) {
                throw new Error(Exanimo.trans('request_failed'));
            }

            return response.json();
        }).then((data) => {
            if (data.ok) {
                document.location.reload(true);
            } else {
                throw new Error(data.error);
            }
        }).catch((err) => {
            this.setState({
                loading: false,
                error: err.message
            });
        });
    }

    componentWillReceiveProps(props) {
        if (props.init) {
            this._resetState();
        }
    }

    _onChangeTeam = (e) => {
        const team = parseInt(e.target.value, 10);

        this.setState({
            teamSelected: team
        });
    }

    render() {

        const customStyles = {
            overlay : {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                zIndex: 2
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                backgroundColor       : '#F1F1F1',
                color                 : '#333333',
                padding               : '0'
            }
        };

        const error = (this.state.error) ? <div className={modalStyle.error}>{this.state.error}</div> : '';
        const saveButtonText = (this.state.loading) ? '. . .' :  Exanimo.trans('save');
        const activeTeam = this.props.teamData[this.state.teamSelected] || this.props.teamData[this.props.teamSelected] || this.props.teamData[Object.keys(this.props.teamData)[0]];
        let header;

        if (!this.props.teamSelected) {
            header = Exanimo.trans('register');
        }

        let roster = [];

        for (let i = 0; i <= this.props.rosterSize - 1; i++) {

            let value = 0;

            if (this.props.roster) {
                value = this.props.roster[i];
            } else if (activeTeam.members[i])  {
                value = activeTeam.members[i].id;
            }

            roster.push(
                <select ref={(select) => {this._selects[i] = select}} data-index={i} defaultValue={value} className={modalStyle.input} key={activeTeam.id + '_' + i}>
                    <option value="0">-</option>
                    {activeTeam.members.map((item, key) => {
                        return <option key={key} value={item.id}>
                                   {item.title}
                               </option>
                    })}
                </select>
            );
        }

        let teams = [];

        for (let i in this.props.teamData) {

            const team = this.props.teamData[i];

            if (this.props.teamSelected && this.props.teamSelected !== this.props.teamData.id) {
                continue;
            }
            teams.push(<option key={team.id} value={team.id}>{team.title}</option>);
        }

        let timeSlots = [];

        if (this.props.timeSlotData) {
            for (let timestamp in this.props.timeSlotData) {
                const {count, full, disabled} = this.props.timeSlotData[timestamp];
                timeSlots.push(<option key={timestamp} disabled={disabled} value={timestamp}>{timestamp} {`| ${Exanimo.trans('places_taken')}:`} {count} / {this.props.timeSlotMaxParticipants} {full && `- ${Exanimo.trans('full')}`}</option>);
            }
        }
        const buttonClasses = cx(modalStyle.button, style.button);
        const teamClasses = cx(modalStyle.input, style.teamSelect);
        const teamSelectAvailable = !this.props.teamSelected;

        return (
            <Modal
                isOpen={this.props.open}
                onRequestClose={this.props.onClose}
                contentLabel="TeamMemberSelector"
                style={customStyles}
            >
                <div className={style.container}>
                    <a href="" onClick={this.props.onClose} className={modalStyle.close}/>

                    <div className={style.content}>
                        {error}
                        {teamSelectAvailable &&
                            <h3 className={style.header}>{header}</h3>
                        }

                        {this.props.timeSlotData &&
                            <div>
                                <p className={modalStyle.subtitle}>{Exanimo.trans('pick_tournament_timeslot')}</p>
                                <div className={style.selectContainer}>
                                    <select ref={(select) => this._timeSlotSelect = select} onChange={this._onChangeTimeslot} className={teamClasses}>
                                        {timeSlots}
                                    </select>
                                </div>
                            </div>
                        }

                        {teamSelectAvailable &&
                            <div>
                                <p className={modalStyle.subtitle}>{Exanimo.trans('team')}</p>
                                <select ref={(select) => this._teamSelect = select} onChange={this._onChangeTeam} className={teamClasses}>
                                    {teams}
                                </select>
                            </div>
                        }

                        <p className={modalStyle.subtitle}>{Exanimo.trans('player_roster')}</p>
                        <div className={style.selectContainer}>{roster}</div>
                        <div className={style.actionContainer}>
                            <a onClick={this._submitForm} className={buttonClasses}>{saveButtonText}</a>
                        </div>
                    </div>
                </div>
            </Modal>);
    }
}

export default TeamMemberSelect;
